import { render, staticRenderFns } from "./rechargeRecords.vue?vue&type=template&id=0c506756&scoped=true"
import script from "./rechargeRecords.vue?vue&type=script&lang=js"
export * from "./rechargeRecords.vue?vue&type=script&lang=js"
import style0 from "./rechargeRecords.vue?vue&type=style&index=0&id=0c506756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c506756",
  null
  
)

export default component.exports